import type { Configuration } from '@azure/msal-browser';

import { PublicClientApplication } from '@azure/msal-browser';

import { AZURE_AD } from 'src/global-config';

const msalConfig: Configuration = {
  auth: {
    clientId: AZURE_AD.clientId,
    authority: AZURE_AD.authority,
    postLogoutRedirectUri: '/',
    redirectUri: '/', // Resolve the redirectUri issue
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
export const scopes = ['openid', 'profile', 'User.Read'];

const initializeMsal = async (): Promise<void> => {
  await msalInstance.initialize();

  try {
    await msalInstance.handleRedirectPromise();
  } catch (error) {
    console.error('Error handling redirect:', error);
  }
};

// Initialize MSAL to avoid empty accounts
initializeMsal();

export const getAuthToken = async (): Promise<
  | {
      idToken: string;
      sessionId: string | undefined;
      username: string;
    }
  | undefined
> => {
  const accounts = msalInstance.getAllAccounts();

  if (accounts.length === 0) {
    return undefined;
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: [], // empty scope to avoid 401 error
      account: accounts[0],
    });

    return {
      idToken: response.idToken,
      sessionId: response.account.idTokenClaims?.oid,
      username: response.account.username,
    };
  } catch (error) {
    console.error('Error retrieving token:', error);
    throw new Error('Failed to retrieve token');
  }
};
